export default __webpack_public_path__ + "static/media/Happy_cat.01bde461.png";